// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import axios from "axios";
// import { Helmet } from "react-helmet-async";
// // CSS
// import "./menu-page.css";

// // Sections
// import MenuHero from "../../components/MenuHero/MenuHero";
// import MenuCategories from "../../components/MenuCategories/MenuCategories";
// import FullMenu from "../../components/FullMenu/FullMenu";

// const Menu = () => {
//   const location = useLocation();
//   const queryParams = new URLSearchParams(location.search);
//   const initialCategory = queryParams.get("category") || "All";

//   const [selectedCategory, setSelectedCategory] = useState(initialCategory);
//   const [items, setItems] = useState([]);

//   //api call
//   useEffect(() => {
//     const fetchItems = async () => {
//       try {
//         const response = await axios.get(
//           "https://ekhoni-khabo-server.vercel.app/api/v1/menu/get-items",
//         );
//         setItems(response.data.items);
//       } catch (error) {
//         console.error("Error fetching items:", error);
//       }
//     };
//     fetchItems();
//   }, []);

//   useEffect(() => {
//     setSelectedCategory(initialCategory);

//     if (location.hash === "#full-menu") {
//       const fullMenuSection = document.getElementById("full-menu");
//       if (fullMenuSection) {
//         fullMenuSection.scrollIntoView({ behavior: "smooth" });
//       }
//     }
//   }, [initialCategory, location.hash]);

//   const handleCategoryClick = (category) => {
//     setSelectedCategory(category);
//   };

//   return (
//     <>
//       <Helmet>
//         {/* Meta Pixel Code */}
//         <script>
//           {`
//             !function(f,b,e,v,n,t,s)
//             {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
//             n.callMethod.apply(n,arguments):n.queue.push(arguments)};
//             if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
//             n.queue=[];t=b.createElement(e);t.async=!0;
//             t.src=v;s=b.getElementsByTagName(e)[0];
//             s.parentNode.insertBefore(t,s)}(window, document,'script',
//             'https://connect.facebook.net/en_US/fbevents.js');
//             fbq('init', '26662731300068867');
//             fbq('track', 'PageView');
//           `}
//         </script>
//         <noscript>
//           <img
//             height="1"
//             width="1"
//             style={{ display: "none" }}
//             src="https://www.facebook.com/tr?id=26662731300068867&ev=PageView&noscript=1"
//             alt=""
//           />
//         </noscript>
//       </Helmet>
//       <main className="menu-page">
//         <MenuHero />
//         <MenuCategories onCategoryClick={handleCategoryClick} />
//         <FullMenu selectedCategory={selectedCategory} items={items} />
//       </main>
//     </>
//   );
// };

// export default Menu;

//pages/Menu/Menu.jsx
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet-async"; // Keep this for page SEO
// CSS
import "./menu-page.css";

// Sections
import MenuHero from "../../components/MenuHero/MenuHero";
import MenuCategories from "../../components/MenuCategories/MenuCategories";
import FullMenu from "../../components/FullMenu/FullMenu";

const Menu = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const initialCategory = queryParams.get("category") || "All";

  const [selectedCategory, setSelectedCategory] = useState(initialCategory);
  const [items, setItems] = useState([]);

  //api call
  useEffect(() => {
    const fetchItems = async () => {
      try {
        const response = await axios.get(
          "https://ekhoni-khabo-server.vercel.app/api/v1/menu/get-items",
        );
        setItems(response.data.items);
      } catch (error) {
        console.error("Error fetching items:", error);
      }
    };
    fetchItems();
  }, []);

  useEffect(() => {
    setSelectedCategory(initialCategory);

    if (location.hash === "#full-menu") {
      const fullMenuSection = document.getElementById("full-menu");
      if (fullMenuSection) {
        fullMenuSection.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [initialCategory, location.hash]);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };

  return (
    <>
      <Helmet>
        {/* Page-specific SEO tags only */}
        <title>Menu | Ekhoni Khabo - Explore Our Delicious Dishes</title>
        <meta
          name="description"
          content="Browse our extensive menu of appetizers, main courses, desserts, and beverages. Order online for fast delivery!"
        />
        <meta property="og:title" content="Ekhoni Khabo Menu" />
        <meta
          property="og:description"
          content="Check out our delicious restaurant menu"
        />
      </Helmet>

      <main className="menu-page">
        <MenuHero />
        <MenuCategories onCategoryClick={handleCategoryClick} />
        <FullMenu selectedCategory={selectedCategory} items={items} />
      </main>
    </>
  );
};

export default Menu;
